const STATS = [
  { icon: "ri-check-double-line", value: "1.620+", label: "Proje / Tabela" },
  { icon: "ri-medal-2-line", value: "20+", label: "Yıllık Tecrübe" },
  { icon: "ri-building-line", value: "300+", label: "Mutlu Marka" },
  { icon: "ri-tools-line", value: "2.000+", label: "Üretim Kapasitesi" },
  { icon: "ri-map-pin-line", value: "18", label: "Şehirde Aktif Proje" },
];

const StatsBar = () => (
  <section className="bg-white border-y border-[#E8E8E8]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-x divide-[#E8E8E8]">
        {STATS.map((s) => (
          <div
            key={s.label}
            className="flex flex-col items-center text-center py-10 px-6 anim-scale"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-[#FFF8DC] mb-4">
              <i className={`${s.icon} text-[#E6A800] text-lg`} />
            </div>
            <div className="font-head font-black text-[#0D0D0D] text-5xl leading-none mb-2">
              {s.value}
            </div>
            <div className="font-head text-[#737373] text-xs font-600 uppercase tracking-[0.18em]">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsBar;